// export const BASE_URL = "https://api-beta.lywo.in/"; /* Stage */

// export const BASE_URL = 'https://api-admin-lywo.azurewebsites.net/'

// export const BASE_URL = 'https://api.lywo.in/'

export const BASE_URL = "https://api-qa-lywo-beta-f5fxbdbqdjgbg0cv.southindia-01.azurewebsites.net/"  //testing

export const USER_WEB_URL = 'https://apply.test.lywo.in/'

// export const USER_WEB_URL = "https://apply.lywo.in/"
// export const USER_WEB_URL = "https://user.apply.lywo.in/"
// const BASE_URL_AI = "https://lywo-genai.cloudxperte.com/";

// Azure Vase Url

// export const BASE_URL = 'https://lywo-admin-dnet-d0eadshrhvgdbxg4.eastus-01.azurewebsites.net/'
// const BASE_URL_AI = 'https://lywo-genai.azurewebsites.net/' 

const BASE_URL_AI = 'https://api.genai.lywo.in/' // aws

const BASE_URL_PUBLISH = "https://api-lywo-beta.azurewebsites.net/"


export const ApiConfig = {
  ACCESS_CODE_LIST: BASE_URL + "api/CandidateMgmt/AdminUniqueCodeUserdtls?",
  GET_OTP_WITH_EMAIL: BASE_URL + "api/Account/AdminAuthorizeEmail",
  LOGIN_WITH_VALID_OTP: BASE_URL + "api/Account/AdminValidatedOTP",
  DOWNLOAD_EXCEL:
    BASE_URL + "api/CandidateMgmt/ExportUniqueCodeUserDetails?code=", // pass code
  GROUP_LIST: BASE_URL + "api/CandidateMgmt/GetCodeAccessDtls?email=",
  ADD_JOB: BASE_URL + "api/Job/Insertjobcode",
  GET_CODE_DETAILS: BASE_URL + "api/Job/GetJobCodeDetails?jobcode=",
  DELETE_USER_AND_DEP: BASE_URL + "api/User/DeleteUserAndDependencies?",
  EXCELDOWNLOADFILE: BASE_URL + "api/Assessment/GenerateExcel/generateExcel?UserId=",
  GET_AREA_OF_EDUCATION: BASE_URL + "api/CommonDropDown/GetSpecializations?currentUserId=1",
  GET_INDUSTRY_LIST: BASE_URL + "api/Organization/GetIndustryList",
  SEND_ASSESSMENT_REMINDER: BASE_URL + "api/Assessment/SendAssessementReminder",
  GET_LAST_EMAIL_CONTENT: BASE_URL + "api/Assessment/GetLastEmailContent",
  SELECT_STATUS: BASE_URL + "api/CandidateMgmt/UpdateSatus",
  GET_EMAIL_CONTENT: BASE_URL + "api/Assessment/GetEmailContent",
  GET_AUTHENTICATED_SENDERS: BASE_URL + "api/Assessment/GetAuthenticatedSenders",
  DOWNLOAD_USER_RESPONSES: BASE_URL + 'api/Assessment/GenerateCandidateAnswersExcel?CodeId=',
  ACTIVEDEACTIVECODE: BASE_URL + 'api/Job/ActiveDeActiveJobCode',
  ADD_UPDATE_COMP: BASE_URL + 'api/Job/UpsertCompany',
  GET_COMPANY_LIST: BASE_URL + 'api/Job/GetCompanyList',
  GET_COMPANY_DETAIL: BASE_URL + 'api/Job/GetCompany?companyId=',
  SAVE_QUIZ_QUST: BASE_URL + 'api/Job/SaveQuizOptions',
  GET_JD_JOB_CODES_LIST: BASE_URL + 'api/Job/GetJDJobCodesList',
  POST_TEMP_JOB_CODE: BASE_URL + 'api/Job/CreateTempJobcode',
  GET_TEMP_JOB_CODE: BASE_URL + 'api/Job/GetQuizList?jobcode=',
  DELETE_JOB_CODE: BASE_URL + 'api/Job/DeleteJobcode?jobcode=',
  GET_DRAFT_JOBCODE_LIST: BASE_URL + 'api/Job/GetDraftJobCodesList',
  GET_JD_DETAILS: BASE_URL + 'api/Job/GetJD?JDJobInformationId=',
  UPDATE_CANDIDATE_STATUS: BASE_URL + 'api/CandidateMgmt/EditCandidateStatus',
  DELETE_USER_IN_BULK: BASE_URL + '/api/User/DeleteUserBulk',
  GET_USER_LOGS: BASE_URL + "api/CandidateMgmt/GetUserActivityLog?userId=",
  UPDATE_QUIZ_SCORE: BASE_URL + 'api/CandidateMgmt/UpdateQuizScores?code=',
  SAVE_ADVANCE_FILTER: BASE_URL + 'api/Assessment/UpsertAdvanceFilter',
  GET_FILTERS_LIST: BASE_URL + 'api/Assessment/GetAdvanceFilterList',
  GET_DEPARTMENT_LIST: BASE_URL + 'api/CommonDropDown/GetDepartmentsList',
  DOWNLOAO_JD: BASE_URL + "api/Job/ExportJDPDF",
  UPDATE_TO_UN_PUBLISH_JD: BASE_URL + 'api/Job/UnPublishJD?jobinfoid=',
  DOWNLOAD_QUIZ: BASE_URL + 'api/Assessment/ExportQuiz?QuizId=',
  DOWNLOAD_WORD_FILE: BASE_URL + 'api/Job/ExportJDWord',
  AUTHORIZE_WITH_TOKEN: BASE_URL + 'api/Account/AdminAuthorizeViaToken?token=',
  GET_NOTES: BASE_URL + 'api/CandidateMgmt/GetNotes?',
  ADD_NOTE: BASE_URL + 'api/CandidateMgmt/AddNote',
  GET_EXCEL_QUIZ_EMAIL_MATCH: BASE_URL + 'api/CandidateMgmt/GetExcelQuizMatch?code=',
  UPDATE_QUIZ_SCORE_MAIL: BASE_URL + 'api/CandidateMgmt/UpdateQuizScoreExcel',
  GET_SUMMARY_REPORT: BASE_URL + 'api/CandidateMgmt/GetSummaryReport?',
  UPDATE_TAGS: BASE_URL + 'api/CandidateMgmt/UpdateTags',
  UPDATE_CREDIT: BASE_URL + '/api/CandidateMgmt/ConsumeCredit',
  SAVE_PERSONALITY_REPORT: BASE_URL + 'api/CandidateMgmt/SaveDetailPersonalityReport',
  GET_TAGS_BY_CODE: BASE_URL + 'api/CandidateMgmt/GetTags?Code=',
  ADD_CUSTOM_TAG: BASE_URL + 'api/CandidateMgmt/UpdateTagsExcel',
  BULK_SUMMARY_REPORT: BASE_URL + 'api/CandidateMgmt/GetSummaryReportBulk',
  GET_MANUAL_MATCH: BASE_URL + 'api/CandidateMgmt/GetManualQuizMatchData?code=',
  UPDATE_SINGLE_QUIZ_SCORE: BASE_URL + 'api/CandidateMgmt/UpdateSingleQuizScore?',
  REQUEST_SUMMARY_REPORT: BASE_URL + 'api/CandidateMgmt/CalltoAISummary?',




  POST_GET_PERSONALITY_MATCHES: BASE_URL + 'api/CandidateMgmt/GetBehaviourPercentage',

  POST_UPDATE_QUIZ: BASE_URL + 'api/Job/UpdateQuiz',
  DELETE_QUIZ: BASE_URL + 'api/Job/DeleteQuiz',


  // AI APi 
  POST_GENERATE_KEYWORDS: BASE_URL_AI + "jd_creation/generate_keywords",
  POST_GENERATE_BEHAVIOUR_QUESTIONS:
    BASE_URL_AI + "jd_creation/generate_behavior_questions",
  POST_GENERATE_BEHAVIOUR: BASE_URL_AI + "jd_creation/generate_behaviour",
  POST_GENERATE_SKILLS: BASE_URL_AI + "jd_creation/generate_skills",
  POST_GENERATE_JOB_DESCRIPTION:
    BASE_URL_AI + "jd_creation/generate_job_description",
  POST_REGENERATE_JOB_DESCRIPTION:
    BASE_URL_AI + "jd_creation/regenerate_job_description",
  POST_GENERATE_JOB_DETAILS: BASE_URL_AI + "jd_creation/generate_job_details",
  POST_REGENERATE_JOB_DETAILS: BASE_URL_AI + "jd_creation/regenerate_job_details",
  POST_REGENERATE_JOB_RESPONSIBILITIES: BASE_URL_AI + "jd_creation/regenerate_job_responsibilities",
  POST_GENERATE_CUSTOM_QUESTIONS: BASE_URL_AI + "jd_creation/generate_custom_questions",
  POST_REGENERATE_KEYWORDS_FOR_USERS: BASE_URL_AI + "jd_creation/regenerate_keywords_for_user",
  POST_REGENERATE_JOB_DETAILS_FOR_USERS: BASE_URL_AI + "jd_creation/regenerate_job_details",

  GET_TOPISC: BASE_URL_AI + 'jd_creation/generate_quiz_topics',
  GET_SUB_TOPICS: BASE_URL_AI + 'jd_creation/generate_sub_topics',
  GET_CUSTOM_SUB_TOPICS: BASE_URL_AI + 'jd_creation/generate_custom_subtopics',
  GET_QUIZ_QUES: BASE_URL_AI + 'jd_creation/generate_quiz',
  REGENERATE_QUIS: BASE_URL_AI + 'jd_creation/regenerate_question',
  POST_PUBLISH_JD: BASE_URL + 'api/Job/UpsertJD',
  UPLOAD_JD: BASE_URL_AI + 'jd_creation/upload_jd',
  GENERATE_CUSTOM_QUESTIONS: BASE_URL_AI + 'jd_creation/generate_custom_questions',
  REPLACE_QUEST: BASE_URL_AI + 'jd_creation/replace_questions ',
  GENERATE_BEHAVIOUR_QUESTION: BASE_URL_AI + 'jd_creation/generate_behavior_questions',
  REGENERATE_SKILL: BASE_URL_AI + 'jd_creation/regenerate_skills',
  GENERATE_PEROSALITY_REPORT: BASE_URL_AI + 'jd_creation/generate_personality_report'
  // http://localhost:51043/api/Job/UpsertJD
};
